import { Model } from "@vuex-orm/core";
import { clientEntity } from "./client-entity";

export interface clientLocationEntity {
  clientLocationId: number;
  clientLocationName: string;
  contactPerson: string;
  phone: string;
  clientId: number;
  isDefault: boolean;
  isDefaultBillingLocation: boolean;
  timeZone: string;
  billingContacts: string;
  tick: number;
  address1: string;
  address2: string;
  state: string;
  city: string;
  country: string;
  phoneExt?: string;
  isActive: boolean;
  zipCode: number;
  updatedById: number;
  updatedOn: string;
  contactId: number;
  index: number;
  isFilled: boolean;
}

export class clientLocationEntity extends Model {
  static entity = "clientLocationEntity";
  static primaryKey = "clientLocationId";
  static fields() {
    return {
      clientLocationId: this.number(0),
      clientLocationName: this.string(null),
      contactPerson: this.attr(null),
      phone: this.attr(null),
      clientId: this.number(0),
      isDefault: this.boolean(false),
      isDefaultBillingLocation: this.boolean(false),
      timeZone: this.attr(null),
      billingContacts: this.string(""),
      tick: this.number(0),
      address1: this.string(""),
      address2: this.string(""),
      state: this.string(""),
      city: this.string(""),
      country: this.string(""),
      phoneExt: this.attr(null),
      isActive: this.boolean(true),
      zipCode: this.attr(null),
      updatedById: this.attr(null),
      updatedOn: this.attr(null),
      contactId: this.attr(null),
      index: this.number(0),
      isFilled: this.boolean(false),
    };
  }

  static beforeSelect(records: any) {
    return records.filter((row: any) => row.clientLocationId != 0);
  }
  get clientLocationWithPhone() {
    if (this.clientId) {
      if (this.phone) {
        return this.clientLocationName + " (" + this.phone + ")";
      }
      return this.clientLocationName;
    }
  }

  get clientLocationWithClient() {
    if (this.clientId) {
      const client = clientEntity.query<any>().find(this.clientId);
      return this.clientLocationName + " (" + client.clientName + ")";
    }
    return this.clientLocationName;
  }

  get billingContactList() {
    if (this.billingContacts) {
      return JSON.parse(this.billingContacts);
    }
    return [];
  }

  get nameForSort(): string {
    const name = this.clientLocationName;
    if (name == null || name === "") {
      return "";
    }
    return String(name).toLowerCase();
  }
}
